import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center mb-l" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 2,
  class: "text-xs text-red-600 text-right mt-[-15px] mb-[20px]"
}
const _hoisted_7 = { class: "flex items-center justify-end" }

import { computed, ref } from "vue";
import { useManagedPatientsStore } from "@/store/managedPatientsStore";
import { localeDateStringFromDate } from "@/helpers/datehelper";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import RoundedCard from "@/components/RoundedCard.vue";
import {
  processBulkCSVFiles,
  PatientWithMedications,
} from "@/helpers/bulkhelper";
import ListTile from "@/components/ListTile.vue";
import UButton from "@/components/UButton.vue";
import { usePublicStore } from "@/store/publicStore";
import { useSessionStore } from "@/store/sessionStore";
import CoreIcon from "@/components/CoreIcon.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { useNotificationStore } from "@/store/notificationStore";
import router from "@/router";
import LabelButton from "@/components/LabelButton.vue";
import { findMedicationWithGtin } from "@/helpers/requestHelpers/medicationRequests";

// HTML-Elemente für den Datei-Upload

export default /*#__PURE__*/_defineComponent({
  __name: 'ManagedPatientsBulkImportView',
  setup(__props) {

const patientsFileInput = ref<any>();
const medicationsFileInput = ref<any>();
const detailView = ref<string>();
const cpg = ref<any>();
const triedToSubmitCreatePatientForm = ref(false);

const patientsWithMedications = ref<PatientWithMedications[]>([]);

const savingPatient = ref<string>();
const importedPatients = ref<boolean>(false);
const savedPatients = ref<Set<string>>(new Set<string>([]));
const importPatients = ref<Set<string>>(new Set<string>([]));

const careProviderGroups = computed(() => {
  return usePublicStore().oppositeGroups;
});

const selectedCareProviderGroup = computed(
  () => useSessionStore().selectedCareProviderGroup
);

function helpText() {
  return selectedCareProviderGroup.value?.is_orderer
    ? "Welche Apotheke liefert Medikamente für diese Patienten?"
    : "Welches Heim bestellt Medikamente für diese Patienten?";
}

async function uploadFiles() {
  const patientsFile = patientsFileInput.value[0]?.file;
  const medicationsFile = medicationsFileInput.value[0]?.file;
  if (patientsFile && medicationsFile) {
    try {
      patientsWithMedications.value = await processBulkCSVFiles(
        patientsFile,
        medicationsFile
      );
    } catch (e) {
      useNotificationStore().notifications.push({
        msg: `Fehler beim Lesen der Dateien: ${e}`,
        type: "danger",
      });
    }
  }
  importPatients.value = new Set(
    patientsWithMedications.value.map((p) => p.profile.ssn)
  );
}

function toggle(ssn: string) {
  detailView.value = detailView.value == ssn ? "" : ssn;
}

async function createManagedPatients() {
  triedToSubmitCreatePatientForm.value = true;
  if (!cpg.value) {
    return;
  }
  let amountOfSavedPatients = 0;
  for (const patient of patientsWithMedications.value) {
    for (const medication of patient.medications) {
      // Set supplierId
      if (selectedCareProviderGroup.value?.is_shop) {
        medication.supplierId = selectedCareProviderGroup.value.id;
      } else {
        medication.supplierId = parseInt(cpg.value);
      }
      // Fetch and set pharmacode
      const res = await findMedicationWithGtin(
        medication.gtin,
        medication.supplierId
      );
      const fetchedMedication = res.data;
      medication.pharmacode = fetchedMedication?.pharmacode ?? -1;
      if (medication.pharmacode === -1) {
        medication.gtin = 0;
      }
    }

    savingPatient.value = patient.profile.ssn;
    if (!importPatients.value.has(patient.profile.ssn)) continue;
    if (savedPatients.value.has(patient.profile.ssn)) continue;
    await useManagedPatientsStore().createManagedPatient(
      {
        firstName: patient.profile.firstName,
        lastName: patient.profile.lastName,
        birthday: patient.profile.birthday,
        sex: patient.profile.sex ? 1 : 0,
      },
      parseInt(cpg.value),
      patient.medications
    );
    amountOfSavedPatients++;
    savedPatients.value.add(patient.profile.ssn);
  }
  if (amountOfSavedPatients > 0) {
    useNotificationStore().notifications.push({
      msg: `${amountOfSavedPatients} Patienten importiert`,
      type: "success",
    });
  } else {
    useNotificationStore().notifications.push({
      msg: `Es wurden keine Patienten für den Import ausgewählt.`,
      type: "info",
    });
  }
  importedPatients.value = true;
  savingPatient.value = "----";
}

function openPatients() {
  router.push("/managedPatients");
}

function goBack() {
  if (window.history.state.back != null) {
    router.go(-1);
    return;
  }

  router.push({ name: "conversations" });
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(LabelButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack())),
        icon: "left",
        class: "items-center mr-m"
      }),
      _createVNode(UmanaHeadline, { h: "h1" }, {
        default: _withCtx(() => [
          _createTextVNode("Mehrere verwaltete Patienten importieren")
        ]),
        _: 1
      })
    ]),
    _createVNode(RoundedCard, null, {
      default: _withCtx(() => [
        (patientsWithMedications.value.length == 0)
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 0,
              type: "form",
              "submit-label": "Vorschau anzeigen",
              onSubmit: uploadFiles
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FormKit, {
                  type: "file",
                  label: "Patienten-CSV",
                  accept: ".csv",
                  help: "Patientenliste auswählen. Die CSV muss ein Semikolon (;) als Trennzeichen verwenden und die Spalten 'Vorname', 'Name', 'SVN', 'Anrede'\nund 'Geburtsdatum' mit genau diesen Namen besitzen.",
                  modelValue: patientsFileInput.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((patientsFileInput).value = $event)),
                  validation: "required"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_FormKit, {
                  type: "file",
                  label: "Medikamenten-CSV",
                  accept: ".csv",
                  help: "Medikamentenliste auswählen. Die CSV muss ein Semikolon (;) als Trennzeichen verwenden und die Spalten 'AHV Patient', 'EAN-Code' und 'Medikament' mit genau diesen Namen besitzen.",
                  modelValue: medicationsFileInput.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((medicationsFileInput).value = $event)),
                  validation: "required"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(patientsWithMedications.value, (patientWithMedications) => {
            return (_openBlock(), _createBlock(ListTile, {
              key: `${patientWithMedications.profile.ssn}`,
              class: _normalizeClass({
            'text-gray-400': !importPatients.value.has(
              patientWithMedications.profile.ssn
            ),
          })
            }, {
              main: _withCtx(() => [
                _createElementVNode("div", {
                  onClick: ($event: any) => (toggle(patientWithMedications.profile.ssn))
                }, [
                  _createTextVNode(_toDisplayString(patientWithMedications.profile.firstName) + " " + _toDisplayString(patientWithMedications.profile.lastName) + ", " + _toDisplayString(_unref(localeDateStringFromDate)(
                  patientWithMedications.profile.birthday
                )) + " ", 1),
                  (detailView.value == patientWithMedications.profile.ssn)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(patientWithMedications.medications, (medication) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: medication.gtin
                          }, _toDisplayString(medication.dscrd) + " (" + _toDisplayString(medication.gtin) + ") ", 1))
                        }), 128)),
                        (patientWithMedications.medications.length == 0)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_4, " Keine Medikamente "))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_2)
              ]),
              trailing: _withCtx(() => [
                (savedPatients.value.has(patientWithMedications.profile.ssn))
                  ? (_openBlock(), _createBlock(CoreIcon, {
                      key: 0,
                      icon: "check"
                    }))
                  : (savingPatient.value == patientWithMedications.profile.ssn)
                    ? (_openBlock(), _createBlock(LoadingSpinner, {
                        key: 1,
                        icon: "check"
                      }))
                    : (importPatients.value.has(patientWithMedications.profile.ssn))
                      ? (_openBlock(), _createBlock(CoreIcon, {
                          key: 2,
                          icon: "checkbox-yes",
                          onClick: ($event: any) => (importPatients.value.delete(patientWithMedications.profile.ssn))
                        }, null, 8, ["onClick"]))
                      : (_openBlock(), _createBlock(CoreIcon, {
                          key: 3,
                          onClick: ($event: any) => (importPatients.value.add(patientWithMedications.profile.ssn)),
                          icon: "checkbox-no"
                        }, null, 8, ["onClick"]))
              ]),
              _: 2
            }, 1032, ["class"]))
          }), 128))
        ]),
        (patientsWithMedications.value.length > 0)
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 1,
              type: "select",
              name: "cpg",
              label: "Zugehöriges Unternehmen",
              help: helpText(),
              modelValue: cpg.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cpg).value = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(careProviderGroups.value, (cpg) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: cpg.id,
                    value: cpg.id
                  }, _toDisplayString(cpg.group_name), 9, _hoisted_5))
                }), 128))
              ]),
              _: 1
            }, 8, ["help", "modelValue"]))
          : _createCommentVNode("", true),
        (
          !cpg.value &&
          patientsWithMedications.value.length > 0 &&
          triedToSubmitCreatePatientForm.value
        )
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Zugehöriges Unternehmen ist erforderlich "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (importedPatients.value)
            ? (_openBlock(), _createBlock(UButton, {
                key: 0,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (openPatients())),
                color: "orange"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Patienten ansehen")
                ]),
                _: 1
              }))
            : (patientsWithMedications.value.length > 0)
              ? (_openBlock(), _createBlock(UButton, {
                  key: 1,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (patientsWithMedications.value = [])),
                  color: "orange"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Abbrechen")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
          (
            patientsWithMedications.value.length > 0 &&
            patientsWithMedications.value.length > savedPatients.value.size
          )
            ? (_openBlock(), _createBlock(UButton, {
                key: 2,
                onClick: createManagedPatients,
                class: "ml-xs"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(importedPatients.value
              ? `weitere Patienten erstellen`
              : `Patienten erstellen`), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})